class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  // Guards against wiping the input when the user is acting on a predictive-search option
  // rather than the reset button.
  //
  // This used to query the whole document, which assumed the only selected option on the
  // page belonged to a predictive dropdown. The GNB language dropdown
  // (snippets/gnb-language-select.liquid) breaks that: its current language is permanently
  // aria-selected and wraps a link, so the query always matched and every reset was
  // cancelled — the search bar's clear button did nothing.
  //
  // Scoping to the enclosing <predictive-search> keeps the original intent. <main-search>
  // sits inside it, so both instances bound to the same form see the same options; without
  // predictive search there is no wrapper and nothing to guard against.
  shouldResetForm() {
    const scope = this.closest('predictive-search') || this;
    return !scope.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
